export const SET_OFFERING_SELECTED = 'SET_OFFERING_SELECTED';
export const SET_OFFERING_UNSELECTED = 'SET_OFFERING_UNSELECTED';
export const SET_INSTALLATION_SELECTED = 'SET_INSTALLATION_SELECTED';
export const SET_INSTALLATION_UNSELECTED = 'SET_INSTALLATION_UNSELECTED';
export const SET_CARE_PLAN_UNSELECTED = 'SET_CARE_PLAN_UNSELECTED';
export const SET_OFFERING_PART_UNSELECTED = 'SET_OFFERING_PART_UNSELECTED';
